import "./LoginStatusModal.scss";

import { faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export const handleSuccess = (message = "Success") => {
  MySwal.fire({
    position: "top",
    backdrop: false,
    html: (
      <div className="swal-content">
        <div>{message}</div>
        <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
      </div>
    ),
    showConfirmButton: false,
    timer: 1500,
    customClass: {
      popup: "small-swal",
      title: "small-swal-title",
      htmlContainer: "small-swal-text",
    },
  });
};

export const handleError = (message = "Failed") => {
  MySwal.fire({
    position: "top",
    backdrop: false,
    html: (
      <div className="swal-content">
        <div>{message}</div>
        <FontAwesomeIcon icon={faTimesCircle} className="error-icon" />
      </div>
    ),
    showConfirmButton: false,
    timer: 3000,
    confirmButtonColor: "#d33",
    customClass: {
      popup: "small-swal",
      title: "small-swal-title",
      htmlContainer: "small-swal-text",
    },
  });
};
